module.exports = __webpack_public_path__ + "static/media/4. Conjunción, Mixtas en tela, 100 x 100 cm, 2018 copy.529b0fa6.png";